// /* eslint-disable */
// import React from "react";

// const DualCircleProgress = ({ timeliness, accuracy, color1, color2 }) => {
//   const size = 70;
//   const strokeWidth = 6;
//   const radius = (size - strokeWidth) / 2;
//   const circumference = 2 * Math.PI * radius;

//   const calcOffset = (value) =>
//     circumference - (value / 100) * circumference;

//   return (
//     <svg width={size} height={size}>
//       <circle
//         cx={size / 2}
//         cy={size / 2}
//         r={radius}
//         stroke="#CBD5E1"
//         strokeWidth={strokeWidth}
//         fill="none"
//       />
//       <circle
//         cx={size / 2}
//         cy={size / 2}
//         r={radius}
//         stroke={color1}
//         strokeWidth={strokeWidth}
//         fill="none"
//         strokeDasharray={circumference}
//         strokeDashoffset={calcOffset(timeliness)}
//         strokeLinecap="round"
//         transform={`rotate(-90 ${size / 2} ${size / 2})`}
//       />
//       <circle
//         cx={size / 2}
//         cy={size / 2}
//         r={radius - 8}
//         stroke={color2}
//         strokeWidth={strokeWidth - 2}
//         fill="none"
//         strokeDasharray={2 * Math.PI * (radius - 8)}
//         strokeDashoffset={
//           (2 * Math.PI * (radius - 8)) - 
//           (accuracy / 100) * (2 * Math.PI * (radius - 8))
//         }
//         strokeLinecap="round"
//         transform={`rotate(-90 ${size / 2} ${size / 2})`}
//       />
//     </svg>
//   );
// };

// export default DualCircleProgress;

// ############################################################
/* eslint-disable */
import React from "react";

const DualCircleProgress = ({ timeliness, accuracy, color1, color2 }) => {
  const size = 70;
  const strokeWidth = 6;

  const radius = (size - strokeWidth) / 2;  // original outer radius
  const innerRadius = radius - 8;           // original inner radius

  const outerCircumference = 2 * Math.PI * radius;
  const innerCircumference = 2 * Math.PI * innerRadius;

  const calcOffset = (value, circumference) =>
    circumference - (value / 100) * circumference;

  return (
    <svg width={size} height={size}>
      {/* Background outer loop */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke="#CBD5E1"
        strokeWidth={strokeWidth}
        fill="none"
      />

      {/* Outer progress (timeliness) */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke={color1}
        strokeWidth={strokeWidth}
        fill="none"
        strokeDasharray={outerCircumference}
        strokeDashoffset={calcOffset(timeliness, outerCircumference)}
        strokeLinecap="round"
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
      />

      {/* Inner progress (accuracy) */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={innerRadius}
        stroke={color2}
        strokeWidth={strokeWidth}   // SAME width now
        fill="none"
        strokeDasharray={innerCircumference}
        strokeDashoffset={calcOffset(accuracy, innerCircumference)}
        strokeLinecap="round"
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
      />
    </svg>
  );
};

export default DualCircleProgress;
